import React from 'react';
import { Link } from 'react-router-dom';

const PackersMovers = () => {
    return (
        <div className="bg-gray-50 pt-24 pb-16 px-6 md:px-20">
            <div className="max-w-6xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-16">
                    <h1 className="text-5xl font-extrabold text-[#0c24da] mb-4">Packers & Movers</h1>
                    <h2 className="text-2xl font-semibold text-gray-700">Safe, Reliable & Stress-Free Moving Services</h2>
                    <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
                        Whether you're moving home or office, Rajkuruma ensures your belongings are packed, transported, and delivered with the utmost care. We make your relocation smooth, secure, and hassle-free.
                    </p>
                </div>

                {/* Core Services Grid */}
                <div className="grid md:grid-cols-2 gap-8 mb-16">
                    <ServiceSection
                        title="Moving Services"
                        desc="Efficient local and long-distance moving for homes and corporate offices."
                        list={['Household Relocation', 'Office & Corporate Moving', 'Interstate Moving', 'Timely Delivery']}
                    />
                    <ServiceSection
                        title="Packing Services"
                        desc="Professional packing using premium materials to keep your valuables safe."
                        list={['Furniture Wrapping', 'Fragile Item Protection', 'Electronics Packing', 'Organized Labeling']}
                    />
                    <ServiceSection
                        title="Relocation Support"
                        desc="End-to-end assistance for a smooth transition into your new space."
                        list={['Unpacking Assistance', 'Furniture Placement', 'Move Planning', 'Real-Time Updates']}
                    />
                    <ServiceSection
                        title="Storage Solutions"
                        desc="Secure, clean, and monitored storage facilities for your inventory."
                        list={['Short & Long-Term Storage', '24/7 Security', 'Inventory Management', 'Flexible Plans']}
                    />
                </div>

                {/* Why Choose Us */}
                <div className="bg-white p-10 rounded-3xl shadow-lg border-l-8 border-[#f15a24] mb-16">
                    <h3 className="text-3xl font-bold mb-6">Why Customers Trust Rajkuruma</h3>
                    <div className="grid md:grid-cols-2 gap-4 text-gray-700">
                        {[
                            "Experienced & Trained Professionals", "Safe Packing with Premium Materials",
                            "Modern & Well-Maintained Vehicles", "Transparent & Competitive Pricing",
                            "Comprehensive Insurance Support", "24/7 Customer Assistance"
                        ].map((item, i) => (
                            <p key={i} className="flex items-center font-medium">✅ {item}</p>
                        ))}
                    </div>
                </div>

                {/* Final CTA */}
                <div className="text-center bg-[#1a2b4d] p-12 rounded-3xl text-white">
                    <h3 className="text-3xl font-bold mb-4">Ready to Move?</h3>
                    <p className="mb-8">Contact us today for a safe and efficient relocation experience.</p>
                    <Link to="/enquiry" className="bg-[#f15a24] hover:bg-[#d44d18] px-10 py-4 font-bold rounded-full text-lg transition">GET A QUOTE →</Link>
                </div>
            </div>
        </div>
    );
};

const ServiceSection = ({ title, desc, list }) => (
    <div className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition border-t-4 border-[#0c24da]">
        <h4 className="text-2xl font-bold text-[#0c24da] mb-3">{title}</h4>
        <p className="text-gray-600 mb-4">{desc}</p>
        <ul className="grid grid-cols-2 gap-2">
            {list.map((item, i) => <li key={i} className="text-sm font-medium text-gray-500">▹ {item}</li>)}
        </ul>
    </div>
);

export default PackersMovers;